import { GeometryType } from "@evergis/api";
import { LayerSymbol } from "../../../interfaces/style";
import { getRandomColor } from "./getRandomColor";
import { getBlankSymbol } from "./getBlankSymbol";
import { getHexColor, transparentizeColor } from "../../../utils/color";
import { updateSymbolParameter } from "../../../evergis/core/classification/updateSymbolParameter";
import { EditGeometryType } from "../../../evergis/core/attributes/geometryTypes";

const OPACITY = 0.5;

export const getRandomSymbol = (geometryType: GeometryType | EditGeometryType): LayerSymbol => {
  switch (geometryType) {
    case GeometryType.Point:
      return {
        ...getBlankSymbol(geometryType),
        fillColor: getHexColor(getRandomColor(OPACITY)),
      };
    case GeometryType.Polyline:
      return updateSymbolParameter(getBlankSymbol(geometryType), "stroke.color", getHexColor(getRandomColor()));
    case GeometryType.Polygon:
      return updateSymbolParameter(getBlankSymbol(geometryType), "fill.color", getHexColor(getRandomColor()));
    case GeometryType.Multipoint:
      return updateSymbolParameter(
        getBlankSymbol(geometryType),
        "pointSymbol.fillColor",
        getHexColor(getRandomColor(OPACITY)),
      );
    case EditGeometryType.Raster: {
      const strokeColor = getRandomColor();
      const fillColor = transparentizeColor(strokeColor, OPACITY * 100);
      const updateFillColor = updateSymbolParameter(
        getBlankSymbol(geometryType),
        "childSymbols.fill.color",
        getHexColor(fillColor),
      );

      return updateSymbolParameter(updateFillColor, "childSymbols.stroke.color", getHexColor(strokeColor));
    }
    default:
      return null;
  }
};
